// start:ng42.barrel
import './insurance.service';
import './components';
// end:ng42.barrel

